export const SSO_CONFIG = {
  AUTH_URL: process.env.REACT_APP_SSO_AUTH_URL,
  CLIENT_ID: process.env.REACT_APP_SSO_CLIENT_ID,
  RESPONSE_TYPE: process.env.REACT_APP_SSO_RESPONSE_TYPE,
  SCOPE: process.env.REACT_APP_SSO_SCOPE,
  REDIRECT_URI: process.env.REACT_APP_SSO_REDIRECT_URI,
  PROMPT: process.env.REACT_APP_SSO_PROMPT,
};

export const getSSOAuthUrl = () => {
  const params = new URLSearchParams({
    response_type: SSO_CONFIG.RESPONSE_TYPE,
    scope: SSO_CONFIG.SCOPE,
    redirect_uri: SSO_CONFIG.REDIRECT_URI,
    client_id: SSO_CONFIG.CLIENT_ID,
    prompt: SSO_CONFIG.PROMPT,
  });

  return `${SSO_CONFIG.AUTH_URL}?${params.toString()}`;
};
